import React, { useState, useEffect } from "react";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { styles } from "../styles/style";

import { useNavigate, useParams } from "react-router-dom";
import {
 useGetSingleSubadminDetailsQuery,
 useUpdateSubadminMutation
  
} from "../redux/features/user/userApi";

import { toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import PermissionsForm from "../Components/Kyc/PermissionsForm";

const EditSubadmin = () => {
  const [permissions,setPermissions]=useState([]);
const {id}=useParams();
 const {data,isLoading,isSuccess,isError}=useGetSingleSubadminDetailsQuery(id);
const[updateSubadmin,{isLoading:updateLoading,isSuccess:updateSuccess,data:updateData}]=useUpdateSubadminMutation();

  useEffect(() => {
    if (isSuccess && data.status === true) {
      toast.success(data.message);
      setPermissions(data?.data?.permission)
      
    } else if (isSuccess && data.status != true) {
      toast.error(data.message);
    }
  }, [isSuccess, data]);
  useEffect(() => {
    if (updateSuccess && updateData.status === true) {
    
      setPermissions(data?.data?.permission)
      toast.success(updateData.message);
      navigate(-1)
      
    } else if (updateSuccess && updateData.status != true) {
      toast.error(updateData.message);
    }
  }, [updateSuccess, updateData]);
  const navigate = useNavigate();


  const handleUpdate=async()=>{
    const updatedData = {
      ...data?.data,    
      permission: permissions,  
    };
await updateSubadmin(updatedData)
  }

 const {email, username,unique_id}=data?.data || "";

  return (
    <>
      <Navbar />
      <div className="m-4 border ">
        <div className=" flex justify-between px-2">
          <h2 className="font-bold text-xl p-2 text-blue-900">
            SubAdmin Details
          </h2>
          <button
            className="  m-2 px-2 font-bold text-md text-blue-900 border flex"
            onClick={() => navigate(-1)}
          >
            <span className="py-2 px-1">
              <FaLongArrowAltLeft />
            </span>
            Back
          </button>
        </div>

        <form >
          <div className="flex p-4 border-y">
            <div className="md:w-1/2 w-full pr-2">
              <label className={`${styles.label}`}>User Name</label>
              <input
                className={`${styles.input}`}
                type="text"
                id="name"
                name="name"

                value={username}
              />

              <br />
              <br />
              <label className={`${styles.label}`}>Unique Id</label>
              <input
                className={`${styles.input}`}
                readOnly
                value={unique_id}
              />
              <br />
              <br />
              <label className={`${styles.label}`}>Email</label>
              <input
                className={`${styles.input}`}
                type="email"
                name="email"
                id="email"
                readOnly
                value={email}
              />
            </div>
           
          </div>

       <PermissionsForm permissions={permissions} setPermissions={setPermissions} />
          <div className="flex gap-4 p-6">
              <button className={`${styles.button} !w-fit`} type="button" onClick={handleUpdate}>
                Update
              </button>
              <button className={`${styles.button} !w-fit !bg-red-500`}>
                Cancel
              </button>
            </div>
        </form>
      </div>
    </>
  );
};

export default EditSubadmin;
